import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, Users, Settings, LogOut, GraduationCap, MessageSquare, Library } from 'lucide-react';

const Sidebar = ({ activePage, logout }) => {
  return (
    <aside className="w-64 bg-slate-900 text-white flex flex-col fixed h-screen">
      <div className="p-6 border-b border-slate-800">
        <div className=" p-2 rounded mb-3 max-w-[150px]">
          <img 
            src="/logoback.png" alt="Arya Sabhyata Logo" className="h-8 w-auto object-contain" 
            onError={(e) => { e.target.src = "https://placehold.co/120x40/ffffff/003366?text=AS+Group"; e.target.parentElement.className = "mb-3"; }}
          />
        </div>
        <p className="text-[10px] font-black uppercase text-slate-500 tracking-[3px]">Management Suite</p>
      </div>
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        <Link to="/admin" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'admin' || activePage === 'overview' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Overview</span>
        </Link>
        <Link to="/admin/inquiries" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'inquiries' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <Users className="w-5 h-5" /> <span>Admission Inquiries</span>
        </Link>
        <Link to="/admin/messages" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'messages' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <MessageSquare className="w-5 h-5" /> <span>General Messages</span>
        </Link>

        <Link to="/admin/colleges" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'colleges' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <GraduationCap className="w-5 h-5" /> <span>Colleges & Schools</span>
        </Link>
        {/* <Link to="/admin/events" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'events' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Events Management</span>
        </Link> */}
        <Link to="/admin/notices" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'notices' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <Library className="w-5 h-5" /> <span>Notice Board</span>
        </Link>
        
        <div className="pt-4 pb-2 px-4">
          <p className="text-[10px] font-black uppercase text-slate-500 tracking-widest">Website CMS</p>
        </div>
        
        <Link to="/admin/home-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'home-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Home Page</span>
        </Link>
        <Link to="/admin/about-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'about-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <Settings className="w-5 h-5" /> <span>About Page</span>
        </Link>
        <Link to="/admin/gallery-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'gallery-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <Settings className="w-5 h-5" /> <span>Gallery Slider</span>
        </Link>
        <Link to="/admin/blogs" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'blogs' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <MessageSquare className="w-5 h-5" /> <span>Blog & Stories</span>
        </Link>
        <Link to="/admin/student-desk-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'student-desk-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Student Desk</span>
        </Link>
        <Link to="/admin/contact-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'contact-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Contact Page</span>
        </Link>
        <Link to="/admin/footer-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'footer-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <LayoutDashboard className="w-5 h-5" /> <span>Footer Editor</span>
        </Link>
        <Link to="/admin/whatsapp-cms" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'whatsapp-cms' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <MessageSquare className="w-5 h-5" /> <span>WhatsApp Settings</span>
        </Link>

        <div className="pt-4 pb-2 px-4">
          <p className="text-[10px] font-black uppercase text-slate-500 tracking-widest">Dropdown Menus</p>
        </div>

        <Link to="/admin/academic-links" className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg ${activePage === 'academic-links' ? 'bg-amber-600' : 'hover:bg-slate-800'}`}>
          <Library className="w-5 h-5" /> <span>Academic Menu</span>
        </Link>

      </nav>
      <div className="p-4 border-t border-slate-800">
        <button onClick={logout} className="w-full flex items-center space-x-2 px-4 py-2 text-slate-300 hover:bg-red-900/20 rounded-lg transition-colors">
          <LogOut className="w-4 h-4" /> <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
